export function extractContractFormValues(
  contract: Record<string, any> | null | undefined
): Record<string, any> | null {
  if (!contract) return null;
  const snakeKey = contract.form_values ?? contract.form_values_json;
  const camelKey = contract.formValues ?? contract.formValuesJson;
  const nestedSigning = contract.signing ?? {};
  const nested =
    nestedSigning.form_values ??
    nestedSigning.form_values_json ??
    nestedSigning.formValues ??
    nestedSigning.formValuesJson;

  const candidate = camelKey ?? snakeKey ?? nested ?? null;
  if (!candidate) {
    return null;
  }

  if (typeof candidate === "string") {
    try {
      return JSON.parse(candidate);
    } catch {
      return null;
    }
  }

  if (typeof candidate === "object") {
    return candidate as Record<string, any>;
  }

  return null;
}

export function extractPatientNameFromContract(
  contract: Record<string, any> | null | undefined
): string | null {
  if (!contract) return null;

  const explicit =
    contract.patient_full_name ??
    contract.patientFullName ??
    contract.patient_name ??
    contract.patientName ??
    null;
  if (explicit && typeof explicit === "string") {
    return explicit;
  }

  const formValues = extractContractFormValues(contract);
  if (!formValues) return null;

  const formName =
    formValues.patient_full_name ??
    formValues.patientFullName ??
    formValues.patient_name ??
    formValues.patientName ??
    null;

  return typeof formName === "string" ? formName : null;
}
